import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorInterceptorBase } from './error-interceptor.base';

@Injectable()
export class NextGenMFAErrorInterceptor extends ErrorInterceptorBase {
    private router = inject(Router);


    public canHandleError(req: HttpRequest<any>, responseError: HttpErrorResponse): boolean {
        let canHandle: boolean = false;

        if (req.body === null || req.body === undefined || !req.body.split) {
            return canHandle;
        }

        let requestBody = req.body.split('&');
        let grantType = requestBody.find(x => x.includes('grant_type'));

        if (responseError.error &&
            responseError.error.error &&
            responseError.error.error === 'Your device is not registered.' &&
            grantType &&
            (grantType.split('=').slice(-1)[0] === 'nextgen' ||
                grantType.split('=').slice(-1)[0] === 'samlaccess')) {
            canHandle = true;
        }

        return canHandle;
    }

    public handleError(req: HttpRequest<any>, error: HttpErrorResponse): HttpErrorResponse {
        let requestBody = req.body.split('&');
        let grantType = requestBody.find(x => x.includes('grant_type')).split('=').slice(-1)[0];
        let mfaType = 'login';

        if (grantType === 'samlaccess')
            mfaType = 'samlLogin';

        this.router.navigate(['/multifactorauthentication', mfaType]);

        return error;
    }
}
